<template>
  <v-dialog v-model="dialog" persistent :overlay="false" max-width="600px" transition="dialog-transition">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" absolute depressed class="white red--text" rounded bottom right>
        <v-tooltip bottom color="gray darken-3">
          <template v-slot:activator="{ on }">
            <v-icon color="red" dark v-on="on">favorite_border</v-icon>
          </template>
          <span class="font-weight-medium">Add product to favorites</span>
        </v-tooltip>
      </v-btn>
    </template>

    <NotAuth v-on:close-dialog="dialog = false"/>
  </v-dialog>
</template>

<script>
export default {
  components: {
    NotAuth: () => import('@/components/user/NotAuth')
  },
  data() {
    return {
      dialog: false
    }
  }
}
</script>
